import { Input } from './Input'

export const NumberInput = {
  variants: {
    outline: {
      field: Input.variants.outline.field,
      stepper: {
        border: 'none',
      },
      stepperGroup: {
        color: 'blueGray.500',
        top: '0',
      },
    },
  },
  sizes: Input.sizes,
}
